import CustomApplicationState from "@galarson/Store/CustomApplicationState";
import Zone from "@insite/client-framework/Components/Zone";
import { getCurrentUserIsGuest, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import logger from "@insite/client-framework/Logger";
import loadTop100Items from "@galarson/Handlers/Top100Items/Top100ItemsLoad";
import { getOrdersDataView, Top100ItemsDataViewContext } from "@galarson/Handlers/Top100Items/Top100ItemsSelectors";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";

const mapStateToProps = (state: CustomApplicationState) => {
    const session = getSession(state);
    return {
    settings: getSettingsCollection(state),
    top100ItemsDataView: getOrdersDataView(state),
    getTop100ItemsApiParameter: state.customData.Top100Item.getTop100ItemsApiParameter,
    location: getLocation(state),
    isSignInPage: getCurrentPage(state).type === "SignInPage",
    userName: state.context.session.userName,
    currentUserIsGuest: getCurrentUserIsGuest(state),
    signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
    currentLocation: getLocation(state),
    billTo: getBillToState(state, session.billToId).value,
}
};

const mapDispatchToProps = {
    loadTop100Items,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const Top100ItemsPage = ({
    loadTop100Items,
    top100ItemsDataView,
    id,
    getTop100ItemsApiParameter,
    userName,
    currentUserIsGuest,
    isSignInPage,
    signInUrl,
    currentLocation,
    history,
    billTo
}: Props) => {
    
    useEffect(() => {
        if ((!userName || currentUserIsGuest) && !isSignInPage) {
            if (!signInUrl) {
                logger.warn("No url was found for SignInPage, defaulting to /SignIn");
                history.push("/SignIn");
            } else {
                const returnUrl = currentLocation.pathname + currentLocation.search;
                if (returnUrl === "/") {
                    history.push(`${signInUrl}`);
                } else {
                    history.push(`${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}`);
                }
            }

        } else {
            if(billTo?.customerNumber){
                const updatedApiParameter = {...getTop100ItemsApiParameter, customerNumber: billTo?.customerNumber }
                loadTop100Items(updatedApiParameter as any);
            }
        }
    },[billTo?.customerNumber]);

    return (
        <Page
            data-test-selector="top100Items"
            css={css`
                position: relative;
            `}
        >
            <Top100ItemsDataViewContext.Provider value={top100ItemsDataView}>
                <Zone contentId={id} zoneName="Content" />
            </Top100ItemsDataViewContext.Provider>
        </Page>
    );
};

const pageModule: PageModule = {
    component: withHistory(connect(mapStateToProps, mapDispatchToProps)(Top100ItemsPage)),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

export const Top100ItemsPageContext = "Top100ItemsPage";
